import { formatDate } from '@helpers/date';
import { ReactComponent as SvgLocation } from '@img/icons/vacancy-location.svg';
import { ReactComponent as SvgSalary } from '@img/icons/vacancy-salary.svg';
import * as React from 'react';
import { LinkButton } from '../Buttons/GeneralButton/Button';
import S from './VacancyCard2.styles';
const VacancyCard = (props) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.Title, null, props.jobTitle),
        React.createElement(S.Metadata, null,
            props.location && (React.createElement(S.MetadataItem, null,
                React.createElement(S.MetadataItemIcon, { as: SvgLocation }),
                React.createElement(S.MetadataItemValue, null, props.location))),
            props.salary && (React.createElement(S.MetadataItem, null,
                React.createElement(S.MetadataItemIcon, { as: SvgSalary }),
                React.createElement(S.MetadataItemValue, null, props.salary)))),
        props.applicationClosingDate && (React.createElement(S.Date, null,
            React.createElement(S.DateLabel, null, "Application Closing Date"),
            React.createElement(S.DateValue, null, formatDate(props.applicationClosingDate)))),
        props.url && React.createElement(LinkButton, { branding: "primary", title: "View Job Details", href: props.url })));
};
export default VacancyCard;
